<script setup>
import Commons from '@/shared/utils/commons'
import GridList from '../others/GridList.vue'
import ListFetcher from '@/features/data/presentation/components/ListFetcher.vue'
import { ref, computed } from 'vue'
import SlideDetailView from '../others/SlideDetailView.vue'
import KycDocumentDetails from '../kyc/KycDocumentDetails.vue'
import { getKycStatusDisplay, getKycStatusColor } from '@/shared/formatters/kycFormatter.js'
import Events from '@/events/events.js'


const detailData = ref(null)
const restaurants = ref([])
const riders = ref([])

const restaurantsLoading = ref(true)
const ridersLoading = ref(true)

// Colonnes KYC
const cols = computed(() => [
  {
    name: 'Utilisateur',
    id: 'user',
    value(el) {
      const name = el.userName || '-'
      const email = el.userEmail || '-'
      return [name, email]
    },
  },
  {
    name: 'Type',
    id: 'type',
    filter: {
      key: 'type',
      default: '',
      options: [
        { name: 'Tout', value: '' },
        { name: 'Restaurant', value: 'restaurant' },
        { name: 'Livreur', value: 'rider' },
      ],
    },
    value(el) {
      const typeMap = {
        restaurant: '<span class="text-purple-600 font-medium">Restaurant</span>',
        merchant: '<span class="text-purple-600 font-medium">Marchand</span>',
        rider: '<span class="text-blue-600 font-medium">Livreur</span>',
      }
      return typeMap[el.type] || '-'
    },
  },
  {
    name: 'Mise en ligne',
    id: 'uploadedAt',
    value(el) {
      return el.uploadedAt || el.createdAt
        ? Commons.time(el.uploadedAt || el.createdAt, 'DD MMM YYYY HH:mm')
        : '-'
    },
  },
  {
    name: 'Téléphone',
    id: 'phoneNumber',
    value(el) {
      return el.phoneNumber || '-'
    },
  },
  {
    id: 'kycStatus',
    name: 'Statut',
    filter: {
      key: 'kycStatus',
      default: '',
      options: [
        { name: 'Tout', value: '' },
        { name: 'Approuvé / Validé', value: 'approved' },
        { name: 'En attente / Soumis', value: 'submitted' },
        { name: 'Rejeté', value: 'rejected' },
      ],
    },
    value(el) {
      const status = getKycStatusDisplay(el.kycStatus || el.status)
      const colors = getKycStatusColor(el.kycStatus || el.status)
      return `<div style="background-color: ${colors.background}; color: ${colors.color}" class="inline-block px-4 py-1 rounded-full font-semibold text-sm">${status}</div>`
    },
  },
  {
    name: '',
    id: 'action',
    icon: () => '/images/icons/eye.png',
    onClick(el) {
      detailData.value = el
    },
    value() {},
  },
])

const refreshKycData = () => {
  detailData.value = null
  Events.dispatch('updateKyc')
}
</script>

<template>
  <div class="p-5 h-full overflow-auto">
    <GridList
      title="Documents KYC"
      dataKey="kycDocuments"
      :limit="50"

      :elClickHanler="(el)=>{
        detailData = el
      }"
      refreshOnEvents="updateKyc"
      hasSearch
      :cols="cols"
      :cardConfig="{
        titleField: 'userName',
        subtitleField: 'userEmail',
        statusField: 'kycStatus',
        extraFields: [
          { key: 'type', label: 'Type' },
          { key: 'uploadedAt', label: 'Date', type: 'date' }
        ]
      }"
      :gridCols="{ sm: 1, md: 2, lg: 2, xl: 3 }"
    ></GridList>
  </div>

  <div class="hidden">
    <ListFetcher
      dataKey="restaurants"
      @fetched="({items}) => {
        restaurants = items
        restaurantsLoading = false
      }"
    />
    <ListFetcher
      dataKey="riders"
      @fetched="({items}) => {
        riders = items
        ridersLoading = false
      }"
    />
  </div>

  <SlideDetailView :isVisible="!!detailData" @hide="detailData = null">
    <KycDocumentDetails
      v-if="detailData"
      :kycDocumentData="detailData"
      :restaurants="restaurants"
      :riders="riders"
      @refresh="refreshKycData"
    />
  </SlideDetailView>
</template>
